import React from "react";

function Radio({ response, onChange }) {
  return (
    <div className="form-group">
      <div className="row">This field is not editable.</div>
    </div>
  );
}

export default Radio;
